module.exports = __webpack_public_path__ + "media/images/accompanimentIcon-ec2bb0e3.svg";